import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { formatDate } from '../util/dateHelpers';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: theme.spacing(2.375),
  },
}));

const DateBanner = (props) => {
  const [date, setDate] = useState(new Date());
  const classes = useStyles();

  useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, [date]);

  return (
    <div className={props.className}>
      <Typography className={classes.root} noWrap>
        {formatDate(date, true)}
      </Typography>
    </div>
  );
};

export default DateBanner;
